import get from 'lodash.get';

export const selectCurrentPlatform = (state) => {
  const {
    platform: { platforms, selectedId },
  } = state;

  return platforms.find(({ id }) => Number(id) === Number(selectedId)) || {};
};

export const selectCurrentPlatformId = (state) => {
  const {
    platform: { selectedId },
  } = state;

  return selectedId;
};

export const selectPlatformList = (state) => get(state, 'platform.platforms', []);

/**
 * True if platform is deactivated (handles is_deactivate, is_deactivated, 0/1, "true").
 * Note: null/undefined are treated as deactivated, so undefined entries in the platforms
 * array are silently filtered out by selectActivePlatformList rather than causing errors.
 */
export function isPlatformDeactivated(p) {
  if (!p) return true;

  /* Use != null to match both null and undefined; API may omit the key entirely. */
  const directFlag = p.is_deactivate != null ? p.is_deactivate : p.is_deactivated;
  if (directFlag === true || directFlag === 1 || directFlag === '1' || directFlag === 'true') {
    return true;
  }

  const attributs = Array.isArray(p.attributs) ? p.attributs : [];
  const deactivateAttribut = attributs.find((a) => a && a.key === 'is-platform-deactivate');
  const attributValue = deactivateAttribut ? deactivateAttribut.value : null;

  return (
    attributValue === true ||
    attributValue === 1 ||
    attributValue === '1' ||
    attributValue === 'true'
  );
}

/** Platform list without deactivated ones. Use for provider list / headers.
 *  When an admin is logged as a customer (X-Switch-User), return all platforms unfiltered. */
let _prevPlatforms = null;
let _prevLoggedAs = null;
let _cachedActive = [];
export const selectActivePlatformList = (state) => {
  const platforms = selectPlatformList(state);
  const loggedAs = !!get(state, 'authentication.loggedAs');
  if (platforms !== _prevPlatforms || loggedAs !== _prevLoggedAs) {
    _prevPlatforms = platforms;
    _prevLoggedAs = loggedAs;
    _cachedActive = loggedAs ? platforms : platforms.filter((p) => !isPlatformDeactivated(p));
  }
  return _cachedActive;
};
